<template>
  <div class="echarts-container" ref="container"></div>
</template>

<script>
export default {
  name: 'VueEcharts',
  props: ['option'],
  data() {
    return {
      instance: null
    }
  },
  watch: {
    option: {
      handler(option) {
        this.instance.setOption(option)
      }
    }
  },
  mounted() {
    this.instance = this.$echarts.init(this.$refs.container)
    this.instance.setOption(this.option)
  }
}
</script>

<style scoped>
.echarts-container {
  height: 170px;
}
</style>
